//src/admin/AdminHome.js
import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { AdminLanguageContext } from "./context/AdminLanguageContext";
import {
  FaBox,
  FaShoppingCart,
  FaUsers,
  FaDollarSign,
  FaGlobe,
  FaWhatsapp,
  FaStore,
  FaCalendarAlt
} from "react-icons/fa";
import { getAdminDashboardStats } from "../services/adminDashboard.api";
import { useNavigate } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import { getAdminDashboardHistory } from "../services/adminDashboard.api";
import { getAdminProducts } from "../services/adminProducts.api";
import { FaCheckCircle } from "react-icons/fa";
import { getAdminShippingSettings } from "../services/adminShippingSettings.api";
import { FaRegCopy } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { getAdminUsersActivity } from "../services/adminUserActivity.api";
import { saveAdminShippingSettings } from "../services/adminShippingSettings.api";

function AdminHome() {
  const { lang } = useContext(AdminLanguageContext);
  const navigate = useNavigate();

  const sourceRef = useRef(null);
  const dateRef = useRef(null);

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";

const [activityRows, setActivityRows] = useState([]);
const [showLive, setShowLive] = useState(false);

const [toast, setToast] = useState(null);
const [showToast, setShowToast] = useState(false);

const LIVE_MINUTES = 5;

const canAccess = isAdmin || perms.can_view_analytics;

const [sourceOverlayOpen, setSourceOverlayOpen] = useState(false);
const [dateModalOpen, setDateModalOpen] = useState(false);

const [copiedKey, setCopiedKey] = useState(null);

const [dateOverlayOpen, setDateOverlayOpen] = useState(false);
const [dateType, setDateType] = useState("today");

const [initialized, setInitialized] = useState(false);

const [rangeStart, setRangeStart] = useState(null);
const [rangeEnd, setRangeEnd] = useState(null);

const [shippingModalOpen, setShippingModalOpen] = useState(false);
const [shippingForm, setShippingForm] = useState(null);
const [savingShipping, setSavingShipping] = useState(false);

const [lastProduct, setLastProduct] = useState(null);

  // draft filters (UI)
  const [draftSource, setDraftSource] = useState("all");
  const [draftFrom, setDraftFrom] = useState("");
  const [draftTo, setDraftTo] = useState("");
  const [prevStats, setPrevStats] = useState(null);

  const domain = window.location.origin;
  const adminDomain = window.location.origin + "/admin/dashboard";

  const [shipping, setShipping] = useState(null);

  const [history, setHistory] = useState({
  orders: [],
  sales: [],
  users: [],
  products: [],
  labels: [],
});

  // applied filters (API)
  const [filters, setFilters] = useState({
    source: "all",
    from: "",
    to: "",
  });

  
  const copyToClipboard = (text, key) => {
        navigator.clipboard.writeText(text);

        setCopiedKey(key);

        setTimeout(() => {
          setCopiedKey(null);
        }, 1200);
      };

  const resetCalendarRange = () => {
          setRangeStart(null);
          setRangeEnd(null);
        };

  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    orders: 0,
    sales: 0,
    users: 0,
    products: 0,
  });

  const formatSessionDuration = (start) => {
  if (!start || start === "—") return "—";

  const now = new Date();
  const startDate = new Date(start);

  const diffMs = now - startDate;
  const totalSec = Math.floor(diffMs / 1000);

  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
};

 const isLive = (u) => {
  const last = getLatestActivity(u);
  if (!last || last === "—") return false;

  const lastDate = new Date(last);
  const now = new Date();

  const diffMinutes = (now - lastDate) / 1000 / 60;
  return diffMinutes <= LIVE_MINUTES;
};

const getLiveKey = (u) => {
  if (u.email) return `email:${u.email.toLowerCase()}`;
  if (u.phone) return `phone:${u.phone}`;
  if (u.name && u.name !== "Guest") return `name:${u.name.toLowerCase()}`;
  return `guest:${u.id}`;
};

const getLastActivityValue = (u) => {
  const last = getLatestActivity(u);

  if (!last || last === "—") return 0;
  return new Date(last).getTime();
};

const getLatestActivity = (u) => {
  const candidates = [u.lastAction, u.lastVisit].filter(
    (value) => value && value !== "—" && !isNaN(new Date(value).getTime())
  );

  if (!candidates.length) return "—";

  return candidates.sort(
    (a, b) => new Date(b).getTime() - new Date(a).getTime()
  )[0];
};

const dedupeLiveUsers = (items) => {
  const map = new Map();

  items.forEach((u) => {
    const key = getLiveKey(u);
    const existing = map.get(key);

    if (!existing) {
      map.set(key, u);
      return;
    }

    const existingLast = getLastActivityValue(existing);
    const currentLast = getLastActivityValue(u);

    if (currentLast > existingLast) {
      map.set(key, u);
    } else if (currentLast === existingLast) {
      if ((u.actions || 0) > (existing.actions || 0)) {
        map.set(key, u);
      }
    }
  });

  return Array.from(map.values());
};

const liveUsers = dedupeLiveUsers(activityRows.filter(isLive));
  useEffect(() => {
  getAdminShippingSettings()
    .then(setShipping)
    .catch(() => {});
}, []);

  useEffect(() => {
  getAdminProducts()
    .then((res) => {
      if (res?.length) {
        setLastProduct(res[0]); // assuming latest first
      }
    })
    .catch(() => {});
}, []);

useEffect(() => {
  let mounted = true;

  const fetchData = () => {
    getAdminUsersActivity()
      .then((data) => {
        if (mounted) setActivityRows(data);
      })
      .catch(() => {});
  };

  fetchData();

  const interval = setInterval(fetchData, 10000);

  return () => {
    mounted = false;
    clearInterval(interval);
  };
}, []);

  useEffect(() => {
  const handleClickOutside = (e) => {
    // SOURCE
    if (
      sourceRef.current &&
      !sourceRef.current.contains(e.target)
    ) {
      setSourceOverlayOpen(false);
    }

    // DATE
    if (
      dateRef.current &&
      !dateRef.current.contains(e.target)
    ) {
      setDateOverlayOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

useEffect(() => {
  if (!dateModalOpen) return;

  if (draftFrom) setRangeStart(new Date(draftFrom));
  if (draftTo) setRangeEnd(new Date(draftTo));
}, [dateModalOpen]);

  useEffect(() => {
  if (!canAccess) return;

  const today = new Date();
  today.setHours(0,0,0,0);

  const formatted = formatLocalDate(today);

  setDraftFrom(formatted);
  setDraftTo(formatted);

  setFilters(prev => ({
    ...prev,
    from: formatted,
    to: formatted,
  }));

  setInitialized(true); // ✅ IMPORTANT
}, [canAccess]);

  // ✅ default fetch on open (ALL + ALL dates)
  useEffect(() => {
  if (!canAccess || !initialized) return;

  setLoading(true);
  getAdminDashboardStats(filters)
    .then((data) => {
      setPrevStats((prev) => stats);
      setStats(data);
    })
    .catch(() => {})
    .finally(() => setLoading(false));
}, [filters, canAccess, initialized]);

const getTrend = (key) => {
  if (!prevStats) return null;

  const prev = prevStats[key] || 0;
  const curr = stats[key] || 0;

  if (prev === 0) return null;

  const diff = ((curr - prev) / prev) * 100;
  return diff.toFixed(0);
};

useEffect(() => {
  if (!canAccess || !initialized) return;

  getAdminDashboardHistory(filters)
    .then((data) => {

      setHistory({
        orders: data.orders || [],
        sales: data.sales || [],
        users: data.users || [],
        products: data.products || [],
        labels: data.labels || [],
      });
    })
    .catch(() => {});
}, [filters, canAccess, initialized]);

  const TEXT = {
    EN: {
      noAccess: "You are not allowed to access the dashboard",
      weekDays: ["Su","Mo","Tu","We","Th","Fr","Sa"],
      overview: "Overview",
      todayDesc: "Show today data",
      last7Desc: "Last week performance",
      last30Desc: "Last month performance",
      another: "Another",
      customRange: "Choose custom range",
      customDate: "Custom date",
      today: "Today",
      last7: "Last 7 days",
      session: "Session",
  idle: "Idle",
  status: "Status",
   active: "Active",
  idleStatus: "Idle",
  offline: "Offline",
   live: "Live",
      last30: "Last 30 days",
      custom: "Custom",
      date: "Date",
      lebanon: "Lebanon",
      allSources: "All sources",
      orders: "Total Orders",
      sales: "Total Sales",
      users: "Users",
      products: "Products",
      cancel: "Cancel",
      from: "From",
      to: "To",
      apply: "Apply",
      filters: "Filters",
      all: "All",
      website: "Website",
      whatsapp: "WhatsApp",
      store: "Store",
      reset: "Reset",
      showing: "Showing",
      allDates: "All dates",
      quickAccess: "Quick Access",
      settings: "Settings",
      cod: "Cash on Delivery",
      location: "Lebanon",
      domain: "Domain",
      productAdded: "Product added",
      addMore: "Add more",
      themeCustomized: "Theme customized",
      edit: "Edit",
      paymentAvailable: "Payment method available",
      cashOnDelivery: "Cash on delivery",
      contactPayment: "Contact us if you want to add a new payment method",
      shippingFees: "Shipping fees",
      review: "Review",
      client: "Client",
      admin: "Admin",
      copied: "Copied!",
       loading: "Loading...",
  noData: "No data available",
  noLiveUsers: "No users online right now",
  noProduct: "No product yet",
    },
    AR: {
      noAccess: "غير مصرح لك بالوصول إلى لوحة التحكم",
      weekDays: ["أحد","اثنين","ثلثاء","اربعاء","خميس","جمعة","سبت"],
      overview: "نظرة عامة",
      allSources: "كل المصادر",
        active: "نشط",
  idleStatus: "خامل",
  offline: "غير متصل",
    loading: "جارٍ التحميل...",
  noData: "لا توجد بيانات",
  noLiveUsers: "لا يوجد مستخدمون متصلون حالياً",
  noProduct: "لا يوجد منتجات بعد",
      todayDesc: "عرض بيانات اليوم",
      last7Desc: "أداء آخر أسبوع",
      last30Desc: "أداء آخر شهر",
      another: "نطاق آخر",
      customRange: "اختر نطاق مخصص",
      customDate: "تاريخ مخصص",
      session: "الجلسة",
  idle: "الخمول",
  status: "الحالة",
  live: "مباشر",
      lebanon: "لبنان",
      today: "اليوم",
      last7: "آخر 7 أيام",
      last30: "آخر 30 يوم",
      custom: "مخصص",
      date: "التاريخ",
      orders: "إجمالي الطلبات",
      sales: "إجمالي المبيعات",
      users: "المستخدمين",
      products: "المنتجات",
      from: "من",
      to: "إلى",
      cancel: "إلغاء",
      apply: "تطبيق",
      filters: "الفلاتر",
      all: "الكل",
      website: "الموقع",
      whatsapp: "واتساب",
      store: "المتجر",
      reset: "إعادة ضبط",
      showing: "عرض",
      allDates: "كل التواريخ",
      quickAccess: "الوصول السريع",
      settings: "الإعدادات",
      cod: "الدفع عند الاستلام",
      location: "لبنان",
      domain: "النطاق",
      productAdded: "تمت إضافة المنتج",
      addMore: "إضافة المزيد",
      themeCustomized: "تم تخصيص المظهر",
      edit: "تعديل",
      paymentAvailable: "طريقة الدفع متاحة",
      cashOnDelivery: "الدفع عند الاستلام",
      contactPayment: "تواصل معنا لإضافة طريقة دفع جديدة",
      shippingFees: "رسوم الشحن",
      review: "مراجعة",
      client: "الموقع",
      admin: "لوحة التحكم",
      copied: "تم النسخ!",
    },
  }[lang];


  const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const applyDatePreset = (type) => {
  const today = new Date();
  today.setHours(0,0,0,0);

  let from = "";
  let to = "";

  if (type === "today") {
    from = formatLocalDate(today);
    to = from;
  }

  if (type === "7") {
    const start = new Date(today);
    start.setDate(start.getDate() - 6);

    from = formatLocalDate(start);
    to = formatLocalDate(today);
  }

  if (type === "30") {
    const start = new Date(today);
    start.setDate(start.getDate() - 29);

    from = formatLocalDate(start);
    to = formatLocalDate(today);
  }

  // ✅ ADD THIS
  resetCalendarRange();

  setDateType(type);
  setDraftFrom(from);
  setDraftTo(to);

  setFilters(prev => ({
    ...prev,
    from,
    to,
  }));

  setDateOverlayOpen(false);
};

  const resetFilters = () => {
    // reset draft UI
    setDraftSource("all");
    setDraftFrom("");
    setDraftTo("");

    // reset applied filters (this triggers API refresh)
    setFilters({
      source: "all",
      from: "",
      to: "",
    });
  };

  const FilterButton = ({ value, icon, label }) => {
    const active = draftSource === value;
    return (
      <button
        type="button"
        onClick={() => setDraftSource(value)}
        className={`flex items-center gap-2 px-3 py-[6px] rounded-[8px] border text-sm font-semibold transition
          ${
            active
              ? "bg-[#202223] text-white border-[#202223]"
              : "bg-white hover:bg-gray-50 text-gray-900"
          }
        `}
      >
        {icon}
        {label}
      </button>
    );
  };

  // ✅ Active filter summary (based on APPLIED filters)
  const activeSummary = useMemo(() => {
    const sourceLabel =
      filters.source === "all"
        ? TEXT.all
        : filters.source === "website"
        ? TEXT.website
        : filters.source === "whatsapp"
        ? TEXT.whatsapp
        : TEXT.store;

    const fromText = filters.from ? filters.from : null;
    const toText = filters.to ? filters.to : null;

    const datePart =
      !fromText && !toText
        ? TEXT.allDates
        : fromText && toText
        ? `${fromText} → ${toText}`
        : fromText
        ? `${TEXT.from}: ${fromText}`
        : `${TEXT.to}: ${toText}`;

    return `${sourceLabel} · ${datePart}`;
  }, [filters, TEXT]);

  const activeChips = useMemo(() => {
  const chips = [];

  // Source
  if (filters.source !== "all") {
    const label =
      filters.source === "website"
        ? TEXT.website
        : filters.source === "whatsapp"
        ? TEXT.whatsapp
        : TEXT.store;

    chips.push({
      key: "source",
      label,
    });
  }

  // From
  if (filters.from) {
    chips.push({
      key: "from",
      label: `${TEXT.from}: ${filters.from}`,
    });
  }

  // To
  if (filters.to) {
    chips.push({
      key: "to",
      label: `${TEXT.to}: ${filters.to}`,
    });
  }

  return chips;
}, [filters, TEXT]);

const removeChip = (key) => {
  if (key === "source") {
    setDraftSource("all");
    setFilters((prev) => ({ ...prev, source: "all" }));
  }

  if (key === "from") {
    setDraftFrom("");
    setFilters((prev) => ({ ...prev, from: "" }));
  }

  if (key === "to") {
    setDraftTo("");
    setFilters((prev) => ({ ...prev, to: "" }));
  }
};

const formatIdleTime = (lastActivity) => {
  if (!lastActivity || lastActivity === "—") return "—";

  const now = new Date();
  const last = new Date(lastActivity);

  const diffMs = now - last;
  const totalSec = Math.floor(diffMs / 1000);

  const mins = Math.floor(totalSec / 60);
  const secs = totalSec % 60;

  if (mins === 0) return `${secs}s`;
  return `${mins}m ${secs}s`;
};

const formatTimeAgo = (dateValue) => {
  if (!dateValue || dateValue === "—") return "—";

  const now = new Date();
  const date = new Date(dateValue);

  const diffMs = now - date;
  const totalSec = Math.floor(diffMs / 1000);

  const mins = Math.floor(totalSec / 60);
  const hours = Math.floor(mins / 60);
  const days = Math.floor(hours / 24);

  if (totalSec < 60) return `${totalSec}s ago`;
  if (mins < 60) return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;

  return `${days}d ago`;
};

const saveShipping = async () => {
  if (!shippingForm) return;

  setSavingShipping(true);

  try {
    await saveAdminShippingSettings({
      default_fee: shippingForm.default_fee,
    });

    setShipping({
      ...shipping,
      default_fee: shippingForm.default_fee,
    });

    setShippingModalOpen(false);

    // ✅ show toast
    setToast(lang === "AR" ? "تم تحديث رسوم الشحن" : "Shipping fee updated");
    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
      setToast(null);
    }, 2500);

  } catch (e) {
    console.error(e);
  } finally {
    setSavingShipping(false);
  }
};

const getActivityStatus = (u) => {
  const last = getLatestActivity(u);

  if (!last || last === "—") return "offline";

  const diff = (new Date() - new Date(last)) / 1000;

  if (diff <= 60) return "active";
  if (diff <= 300) return "idle";
  return "offline";
};

const StatCard = ({ icon, label, value, route, statKey, history }) => {
  const trend = getTrend(statKey);

  return (
    <div
      onClick={() => navigate(route)}
      className="
      cursor-pointer
      bg-white
      border border-[#e3e3e3]
      rounded-none sm:rounded-[14px]
      p-5
      flex items-center justify-between
      shadow-[0_8px_22px_rgba(0,0,0,0.06)]
      hover:shadow-[0_12px_30px_rgba(0,0,0,0.10)]
      transition
      "
    >
      <div className="flex items-center gap-4">
        <div className="text-3xl text-gray-900">{icon}</div>

        <div>
          <h3 className="text-sm font-medium text-gray-600">
            {label}
          </h3>

          <div className="text-[22px] font-semibold text-gray-900">
            {loading ? (
  <div className="space-y-2">
    <div className="w-20 h-4 bg-gray-200 rounded" />
    <div className="w-14 h-6 bg-gray-300 rounded" />
  </div>
) : (
  value
)}
          </div>
        </div>
      </div>

      {/* MINI CHART */}
{!loading && history[statKey]?.length > 0 && (
  <div className="ml-4">
    <MiniChart
      data={history[statKey]}
      labels={history.labels || []}
    />
  </div>
)}
    </div>
  );
};

const FilterChip = ({ label, onRemove }) => {
  return (
    <div className="
    flex items-center gap-2
    px-3 py-1.5
    bg-white
    border border-gray-300
    rounded-[8px]
    text-[13px]
    text-gray-800
    shadow-[0_1px_2px_rgba(0,0,0,0.05)]
    ">
      <span>{label}</span>

      <button
        onClick={onRemove}
        className="
        w-4 h-4
        flex items-center justify-center
        rounded-full
        text-gray-500
        hover:bg-gray-200
        transition
        "
      >
        ✕
      </button>
    </div>
  );
};

const MiniChart = ({ data = [], labels = [] }) => {
  const [tooltip, setTooltip] = useState(null);

  const width = 110;
  const height = 32;

  if (!data.length) {
  return (
    <div className="text-xs text-gray-400">
      {TEXT.noData}
    </div>
  );
}

  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);

  const points = data.map((v, i) => {
    const x = (i / (data.length - 1 || 1)) * width;
    const y = height - ((v - min) / (max - min || 1)) * height;

    return {
      x,
      y,
      value: v,
      label: labels[i]
          ? new Date(labels[i]).toLocaleDateString(lang === "AR" ? "ar" : "en", {
              month: "short",
              day: "numeric",
            })
          : ""
    };
  });

  const path = points
    .map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`)
    .join(" ");

  return (
    <div className="relative w-[110px] h-[32px]">

      <svg width={width} height={height} className="overflow-visible">

        {/* LINE */}
        <path
          d={path}
          fill="none"
          stroke="#3b82f6"
          strokeWidth="2"
          className="animate-chartLine"
        />

        {/* CROSSHAIR */}
        {tooltip && (
          <line
            x1={tooltip.x}
            y1="0"
            x2={tooltip.x}
            y2={height}
            stroke="#9ca3af"
            strokeDasharray="2,2"
          />
        )}

        {/* POINTS */}
        {points.map((p, i) => (
          <circle
            key={i}
            cx={p.x}
            cy={p.y}
            r="3"
            fill="#3b82f6"
            className="cursor-pointer hover:r-[5] transition"
            onMouseEnter={() =>
              setTooltip({
                x: p.x,
                y: p.y,
                value: p.value,
                label: p.label
              })
            }
            onMouseLeave={() => setTooltip(null)}
          />
        ))}

      </svg>

      {/* TOOLTIP (UPDATED) */}
      {tooltip && (
        <div
          className="
          absolute
          px-2 py-1
          text-[11px]
          bg-gray-900
          text-white
          rounded
          shadow
          pointer-events-none
          whitespace-nowrap
          z-50
          "
          style={{
            left: tooltip.x - 10,
            top: tooltip.y - 30
          }}
        >
          {tooltip.label} • {tooltip.value}
        </div>
      )}

    </div>
  );
};

const CalendarRangePicker = ({ rangeStart, rangeEnd, setRangeStart, setRangeEnd }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const startOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
  const endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);

  const startDay = startOfMonth.getDay();

  const days = [];

  // padding
  for (let i = 0; i < startDay; i++) {
    days.push(null);
  }

  for (let d = 1; d <= endOfMonth.getDate(); d++) {
    days.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d));
  }

  const isSameDay = (a, b) =>
    a && b &&
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const isInRange = (day) => {
    if (!rangeStart || !rangeEnd) return false;
    return day >= rangeStart && day <= rangeEnd;
  };

  const handleClick = (day) => {
    if (!rangeStart || (rangeStart && rangeEnd)) {
      setRangeStart(day);
      setRangeEnd(null);
    } else {
      if (day < rangeStart) {
        setRangeEnd(rangeStart);
        setRangeStart(day);
      } else {
        setRangeEnd(day);
      }
    }
  };

  return (
    <div>

      {/* HEADER */}
      <div className="flex justify-between items-center mb-3 px-2">
        <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() - 1)))}>‹</button>

        <div className="font-semibold text-sm">
          {currentMonth.toLocaleString(lang === "AR" ? "ar" : "en", {
              month: "long",
              year: "numeric",
            })}
        </div>

        <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() + 1)))}>›</button>
      </div>

      {/* WEEK DAYS */}
      <div className="grid grid-cols-7 text-xs text-gray-500 mb-2 px-2">
        {TEXT.weekDays.map(d => (
            <div key={d} className="text-center">{d}</div>
          ))}
      </div>

      {/* DAYS */}
      <div className="grid grid-cols-7 gap-1">
        {days.map((day, i) => {
          if (!day) return <div key={i} />;

          const selected = isSameDay(day, rangeStart) || isSameDay(day, rangeEnd);
          const inRange = isInRange(day);

          return (
            <button
              key={i}
              onClick={() => handleClick(day)}
              className={`
                h-8 rounded-md text-sm
                ${selected ? "bg-black text-white" : ""}
                ${inRange && !selected ? "bg-gray-200" : ""}
                hover:bg-gray-300
              `}
            >
              {day.getDate()}
            </button>
          );
        })}
      </div>

    </div>
  );
};

const PageSkeleton = () => (
  <div className="space-y-6 animate-pulse">

    {/* HEADER */}
    <div className="flex justify-between">
      <div className="w-32 h-6 bg-gray-200 rounded" />
      <div className="w-40 h-8 bg-gray-200 rounded" />
    </div>

    {/* STAT CARDS */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="bg-white p-5 rounded-[14px] border">
          <div className="w-10 h-10 bg-gray-200 rounded mb-4" />
          <div className="w-20 h-4 bg-gray-200 rounded mb-2" />
          <div className="w-16 h-6 bg-gray-300 rounded" />
        </div>
      ))}
    </div>

    {/* QUICK ACCESS */}
    <div className="bg-white p-4 rounded-[16px] border">
      <div className="w-40 h-5 bg-gray-200 rounded mb-4" />
      <div className="grid grid-cols-2 gap-4">
        <div className="h-[200px] bg-gray-200 rounded" />
        <div className="h-[200px] bg-gray-200 rounded" />
      </div>
    </div>

  </div>
);

 return (
  <div className="bg-[#f1f1f1] min-h-screen">
  <main className="xl:p-3 sm:p-5 animate-fadeSlide">
    <div className={`max-w-[1040px] mx-1 ${lang === "AR" ? "lg:-mr-36 lg:ml-auto" : "lg:ml-20 lg:mr-auto"}`}>
    {loading && !initialized ? (
  <PageSkeleton />
) : !canAccess ? (
      <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
        <p className="text-red-700 font-semibold">
          {lang === "AR"
            ? "غير مصرح لك بالوصول إلى لوحة التحكم"
            : "You are not allowed to access the dashboard"}
        </p>
      </div>
    ) : (
      <>
        <div className="flex items-center justify-between mb-5 mt-4 px-2 sm:px-0">

  {/* LEFT */}
  <div className="flex items-center gap-2 mx-1">

  <div className="flex items-center justify-center w-6 h-6">
    <FaHome className="text-gray-900 text-[18px]" />
  </div>

  <h1 className="text-[20px] font-semibold text-gray-900">
    {lang === "AR" ? "الرئيسية" : "Home"}
  </h1>

</div>

  {/* RIGHT (NEW FILTER BUTTONS) */}
  <div className="flex items-center gap-2">

    {/* SOURCE BUTTON */}
    <div className="relative" ref={sourceRef}>
      <button
  onClick={() => setSourceOverlayOpen(v => !v)}
  className="
  flex items-center gap-1
  h-8 px-2 sm:px-3
  bg-[#f6f6f7]
  border border-gray-300
  rounded-lg
  shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
  text-xs sm:text-sm font-medium text-gray-900
  hover:bg-gray-100 hover:shadow-md
  transition
  "
>
  {/* ICON ONLY ON MOBILE */}
  <FaGlobe className="text-[13px] sm:hidden text-gray-600" />

  {/* LABEL (HIDDEN ON MOBILE) */}
  <span className="hidden sm:inline">
    {filters.source === "all"
      ? TEXT.allSources
      : filters.source === "website"
      ? TEXT.website
      : filters.source === "whatsapp"
      ? TEXT.whatsapp
      : TEXT.store}
  </span>

  {/* CLEAN BADGE (ONLY DESKTOP) */}
  {filters.source !== "all" && (
    <span
      onClick={(e) => {
        e.stopPropagation();
        setDraftSource("all");
        setFilters(prev => ({ ...prev, source: "all" }));
      }}
      className="
      hidden sm:inline
      ml-1
      text-xs
      bg-gray-200
      px-1.5
      rounded
      hover:bg-gray-300
      cursor-pointer
      "
    >
      ✕
    </span>
  )}

  {/* CHEVRON */}
  <FiChevronDown className="text-gray-500 text-xs sm:text-sm"/>
</button>

      {/* SOURCE OVERLAY */}
      {sourceOverlayOpen && (
        <div className="
        absolute right-0 top-full mt-1
        w-44
        bg-white
        border border-gray-200
        rounded-xl
        shadow-[0_20px_40px_rgba(0,0,0,0.12)]
        z-50
        animate-sortOverlay
        ">

          {[
              { value: "all", label: TEXT.all, icon: null },
              { value: "website", label: TEXT.website, icon: <FaGlobe /> },
              { value: "whatsapp", label: TEXT.whatsapp, icon: <FaWhatsapp /> },
              { value: "store", label: TEXT.store, icon: <FaStore /> },
            ].map(opt => (
            <button
              key={opt.value}
              onClick={() => {
                setDraftSource(opt.value);
                setFilters(prev => ({ ...prev, source: opt.value }));
                setSourceOverlayOpen(false);
              }}
              className="flex items-center gap-2 w-full px-3 py-2 text-sm hover:bg-gray-100 hover:shadow-md"
            >
              {opt.icon && <span className="text-gray-500">{opt.icon}</span>}
              {opt.label}
            </button>
          ))}

        </div>
      )}
    </div>

<button
  onClick={() => setShowLive((v) => !v)}
  className={`
    h-8 px-3
    rounded-lg
    text-sm font-medium
    transition
    flex items-center gap-2
    shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.16)]
    ${
      showLive
        ? "bg-green-600 text-white hover:bg-green-700"
        : "bg-[#1f1f1f] text-white hover:bg-black"
    }
  `}
>
  {liveUsers.length > 0 ? (
    <span className="relative flex h-2 w-2">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
      <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
    </span>
  ) : (
    <span className="inline-flex h-2 w-2 rounded-full bg-gray-400"></span>
  )}

  {TEXT.live}
</button>

    {/* DATE BUTTON */}
    <div className="relative" ref={dateRef}>
  <button
    onClick={() => setDateOverlayOpen(v => !v)}
    className="
    flex items-center gap-1
    h-8 px-3
    bg-[#1f1f1f]
    text-white
    rounded-lg
    text-sm font-medium
    hover:bg-black
    transition
    "
  >
    <FaCalendarAlt className="text-sm"/>

    <span
  className={`${
    dateType === "custom" && filters.from && filters.to
      ? "text-[9px] sm:text-[10px] truncate max-w-[120px]"
      : ""
  }`}
>
  {dateType === "today" && TEXT.today}
  {dateType === "7" && TEXT.last7}
  {dateType === "30" && TEXT.last30}
  {dateType === "custom" && (
    filters.from && filters.to
      ? `${new Date(filters.from).toLocaleDateString()} → ${new Date(filters.to).toLocaleDateString()}`
      : TEXT.custom
  )}
  {dateType === "all" && TEXT.date}
</span>

    {(filters.from || filters.to) && (
      <span
        onClick={(e) => {
            e.stopPropagation();

            resetCalendarRange(); // ✅ ADD

            setDateType("all");
            setDraftFrom("");
            setDraftTo("");
            setFilters(prev => ({ ...prev, from: "", to: "" }));
          }}
        className="ml-1 text-xs bg-white/20 px-1.5 rounded cursor-pointer"
      >
        ✕
      </span>
    )}
  </button>
  {dateOverlayOpen && (
  <div
  className={`
  absolute top-full mt-1
  ${lang === "AR" ? "left-0" : "right-0"}
  w-[260px]
  bg-white
  border border-gray-200
  rounded-xl
  shadow-[0_20px_40px_rgba(0,0,0,0.15)]
  z-50
  p-2
  animate-sortOverlay
  `}
>

    {/* TODAY */}
    <label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 hover:shadow-md cursor-pointer">
      <input
        type="radio"
        checked={dateType === "today"}
        onChange={() => applyDatePreset("today")}
        className="w-4 h-4 mt-1 accent-gray-800"
      />
      <div>
        <div className="text-sm font-medium">{TEXT.today}</div>
        <div className="text-xs text-gray-500">
          {TEXT.todayDesc}
        </div>
      </div>
    </label>

    {/* 7 DAYS */}
    <label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 hover:shadow-md cursor-pointer">
      <input
        type="radio"
        checked={dateType === "7"}
        onChange={() => applyDatePreset("7")}
        className="w-4 h-4 mt-1 accent-gray-800"
      />
      <div>
        <div className="text-sm font-medium">{TEXT.last7}</div>
        <div className="text-xs text-gray-500">
          {TEXT.last7Desc}
        </div>
      </div>
    </label>

    {/* 30 DAYS */}
    <label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 hover:shadow-md cursor-pointer">
      <input
        type="radio"
        checked={dateType === "30"}
        onChange={() => applyDatePreset("30")}
        className="w-4 h-4 mt-1 accent-gray-800"
      />
      <div>
        <div className="text-sm font-medium">{TEXT.last30}</div>
        <div className="text-xs text-gray-500">
          {TEXT.last30Desc}
        </div>
      </div>
    </label>

    {/* CUSTOM */}
    <label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 hover:shadow-md cursor-pointer">
      <input
        type="radio"
        checked={dateType === "custom"}
        onChange={() => {
          resetCalendarRange(); // ✅ CLEAN START

          setDateType("custom");
          setDateModalOpen(true);
          setDateOverlayOpen(false);
        }}
        className="w-4 h-4 mt-1 accent-gray-800"
      />
      <div>
        <div className="text-sm font-medium">{TEXT.another}</div>
        <div className="text-xs text-gray-500">
          {TEXT.customRange}
        </div>
      </div>
    </label>

    {/* BUTTON */}
    <button
      onClick={() => {
        resetCalendarRange(); // ✅ CLEAN START

        setDateType("custom");
        setDateModalOpen(true);
        setDateOverlayOpen(false);
      }}
      className="
      w-full mt-1
      px-3 py-2
      text-sm
      rounded-lg
      bg-gray-100
      hover:bg-gray-200
      transition
      "
    >
      {TEXT.customDate}
    </button>

  </div>
)}
</div>

  </div>
</div>

{showLive && (
  <div className="mb-5 bg-white border border-green-200 rounded-[14px] shadow-[0_12px_32px_rgba(0,0,0,0.08),0_2px_6px_rgba(0,0,0,0.04)] overflow-hidden">

    <div className="flex items-center justify-between px-4 py-3 border-b border-green-200 bg-green-50">
      <h2 className="text-[15px] font-semibold text-green-800">
        {lang === "AR" ? "المستخدمون المتصلون" : "Live Customers"} ({liveUsers.length})
      </h2>

      <span className="text-sm text-green-700">
        {lang === "AR" ? "نشط خلال آخر" : "Active in last"} {LIVE_MINUTES} {lang === "AR" ? "دقائق" : "minutes"}
      </span>
    </div>

    <div className="p-3 sm:p-4">
      {liveUsers.length === 0 ? (
        <div className="text-center py-6 text-gray-500">
  <FaUsers className="mx-auto text-2xl mb-2 opacity-50" />
  <p className="text-sm">{TEXT.noLiveUsers}</p>
</div>
      ) : (
         <>
        {/* MOBILE VIEW */}
<div className="sm:hidden space-y-3">
  {liveUsers.map((u) => (
    <div
      key={u.id}
      className="bg-[#f9f9f9] border border-gray-200 rounded-xl p-3 text-sm"
    >
      {/* TOP */}
      <div className="flex justify-between items-center mb-2">
        <div className="font-semibold text-gray-900">
          {u.name}
        </div>

        <div>
          {getActivityStatus(u) === "active" && (
            <span className="text-green-600 text-xs">● {TEXT.active}</span>
          )}
          {getActivityStatus(u) === "idle" && (
            <span className="text-yellow-600 text-xs">● {TEXT.idleStatus}</span>
          )}
          {getActivityStatus(u) === "offline" && (
            <span className="text-gray-400 text-xs">● {TEXT.offline}</span>
          )}
        </div>
      </div>

      {/* INFO GRID */}
      <div className="grid grid-cols-2 gap-2 text-xs text-gray-600">

        <div>
          <span className="block text-gray-400">
            {lang === "AR" ? "الهاتف" : "Phone"}
          </span>
          {u.phone || "—"}
        </div>

        <div>
          <span className="block text-gray-400">
            {lang === "AR" ? "الإجراءات" : "Actions"}
          </span>
          {u.actions}
        </div>

        <div>
          <span className="block text-gray-400">
            {TEXT.session}
          </span>
          {formatSessionDuration(u.sessionStart)}
        </div>

        <div>
          <span className="block text-gray-400">
            {TEXT.idle}
          </span>
          {formatIdleTime(getLatestActivity(u))}
        </div>

      </div>

      {/* LAST ACTIVITY */}
      <div className="mt-2 text-xs text-green-700 font-medium">
        {formatTimeAgo(getLatestActivity(u))}
      </div>

    </div>
  ))}
</div>

{/* DESKTOP TABLE */}
<div className="hidden sm:block overflow-x-auto">
  <table className="min-w-full text-center">
            <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
              <tr>
                <th className="px-4 py-2">{lang === "AR" ? "الاسم" : "Name"}</th>
                <th className="px-4 py-2">{lang === "AR" ? "الهاتف" : "Phone"}</th>
                <th className="px-4 py-2">{lang === "AR" ? "الإجراءات" : "Actions"}</th>
                <th className="px-4 py-2">{TEXT.session}</th>
                <th className="px-4 py-2">{TEXT.idle}</th>
                            <th className="px-4 py-2">{TEXT.status}</th>
                <th className="px-4 py-2">{lang === "AR" ? "آخر نشاط" : "Last Activity"}</th>
              </tr>
            </thead>

            <tbody>
              {liveUsers.map((u) => (
                <tr
  key={u.id}
  className="border-b border-[#f1f1f1] text-[13px] hover:bg-[#f6f6f7] transition"
>
  <td className="px-4 py-3 font-medium text-gray-900">
    {u.name}
  </td>

  <td className="px-4 py-3 text-gray-600">
    {u.phone || "—"}
  </td>

  <td className="px-4 py-3 text-gray-900 font-medium">
    {u.actions}
  </td>

  <td className="px-4 py-3 text-gray-600 font-medium">
    {formatSessionDuration(u.sessionStart)}
  </td>

  <td className="px-4 py-3 text-gray-500">
    {formatIdleTime(getLatestActivity(u))}
  </td>

  <td className="px-4 py-3">
    {getActivityStatus(u) === "active" && (
      <span className="text-green-600 font-medium">● {TEXT.active}</span>
    )}
    {getActivityStatus(u) === "idle" && (
      <span className="text-yellow-600 font-medium">● {TEXT.idleStatus}</span>
    )}
    {getActivityStatus(u) === "offline" && (
      <span className="text-gray-400 font-medium">● {TEXT.offline}</span>
    )}
  </td>

  <td className="px-4 py-3 text-green-700 font-medium">
    {formatTimeAgo(getLatestActivity(u))}
  </td>
</tr>
              ))}
            </tbody>
          </table>
        </div>
        </>
      )}
    </div>
  </div>
)}

        {/* CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 sm:gap-4 -mx-2 sm:mx-0">

          <StatCard
            icon={<FaShoppingCart />}
            label={TEXT.orders}
            value={stats.orders}
            route="/admin/orders"
            statKey="orders"
            history={history}
          />

          <StatCard
            icon={<FaDollarSign />}
            label={TEXT.sales}
            value={`$${stats.sales}`}
            route="/admin/orders"
            statKey="sales"
            history={history}
          />

          <StatCard
            icon={<FaUsers />}
            label={TEXT.users}
            value={stats.users}
            route="/admin/customers"
            statKey="users"
            history={history}
          />

          <StatCard
            icon={<FaBox />}
            label={TEXT.products}
            value={stats.products}
            route="/admin/products"
            statKey="products"
            history={history}
          />

        </div>

        {/* ACTIVE FILTER */}
        <div className="mt-6 mx-2 sm:mx-0">
          <div className="
              inline-flex items-center gap-2
              px-3 py-1.5
              rounded-[10px]
              bg-[#f6f6f7]
              border border-gray-200
              text-[13px]
              text-gray-900
              ">
            <span className="font-semibold">{TEXT.showing}:</span>
            <span>{activeSummary}</span>
          </div>
        </div>

        {/* ================= QUICK ACCESS SECTION ================= */}
<div className="mt-6 mb-6 sm:mb-0">

  <div className="
    bg-white
    border border-gray-200
    rounded-[16px]
    p-4
    shadow-[0_10px_30px_rgba(0,0,0,0.06)]
  ">

    {/* ROW 1 */}
    <div className="grid grid-cols-2 gap-4 mb-4">

      {/* PRODUCTS */}
      <div
  onClick={() => navigate("/admin/products")}
  className="
relative
h-[260px] sm:h-[440px]
bg-gray-50
rounded-[12px]
flex flex-col items-center justify-center
hover:bg-gray-100 hover:shadow-md
transition
overflow-hidden
cursor-pointer
"
>

  {/* IMAGE */}
  {loading ? (
  <div className="w-24 h-24 bg-gray-200 rounded animate-pulse" />
) : lastProduct?.image ? (
    <>
      <img
        src={lastProduct.image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover blur-xl opacity-20 scale-110"
      />
      <img
        src={lastProduct.image}
        alt=""
        className="h-[120px] sm:h-[200px] object-contain relative z-10"
      />
    </>
  ) : (
    <div className="text-center text-gray-400">
  <FaBox className="text-3xl mx-auto mb-2" />
  <p className="text-xs">{TEXT.noProduct}</p>
</div>
  )}

  {/* STATUS */}
  <div className="absolute bottom-12 sm:bottom-3 left-3 flex items-center gap-2 text-[13px] sm:text-[14px]">
    <FaCheckCircle className="text-gray-900" />
    <span className="text-gray-900 font-semibold">{TEXT.productAdded}</span>
  </div>

  {/* BUTTON */}
  <button
    onClick={(e) => {
      e.stopPropagation(); // 🔥 important
      navigate("/admin/products");
    }}
    className="absolute bottom-3 right-3 z-20
    h-8 px-3
    bg-[#f6f6f7]
    border border-gray-300
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
    text-sm font-medium text-gray-900
    hover:bg-gray-100 hover:shadow-md
    transition"
  >
    {TEXT.addMore}
  </button>

</div>

      {/* SETTINGS */}
      <div
  onClick={() => navigate("/admin/settings")}
  className="
relative
h-[260px] sm:h-[440px]
bg-gray-50
rounded-[12px]
flex flex-col items-center justify-center
hover:bg-gray-100 hover:shadow-md
transition
cursor-pointer
"
>

  <img
    src="/logo-512x512.png"
    alt="logo"
    className="h-[120px] sm:h-[200px] object-contain relative z-10"
  />

  <div className="absolute bottom-12 sm:bottom-3 left-3 flex items-center gap-2 text-[13px] sm:text-[14px]">
    <FaCheckCircle className="text-gray-900" />
    <span className="text-gray-900 font-semibold">{TEXT.themeCustomized}</span>
  </div>

  <button
    onClick={(e) => {
      e.stopPropagation(); // 🔥 important
      navigate("/admin/settings");
    }}
    className="absolute bottom-3 right-3 z-20
    h-8 px-3
    bg-[#f6f6f7]
    border border-gray-300
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
    text-sm font-medium text-gray-900
    hover:bg-gray-100 hover:shadow-md
    transition"
  >
    {TEXT.edit}
  </button>

</div>

    </div>

    {/* ROW 2 */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">

      {/* COD */}
      <div className="
h-[120px]
bg-gray-100
rounded-[10px]
p-3
flex flex-col justify-between
 text-gray-900
hover:shadow-md transition
">

  <div className="font-semibold">
    {TEXT.paymentAvailable}
  </div>

  <div className="flex items-center gap-2">
    <div className="
          px-2 py-[4px]
          rounded-[6px]
          text-[10px] font-semibold
          text-white
          bg-gradient-to-r from-orange-400 to-yellow-400
          shadow
          ">
            COD
          </div>
    <span className="text-xs">{TEXT.cashOnDelivery}</span>
  </div>

  <div className="text-gray-500 text-xs">
    {TEXT.contactPayment}
  </div>

</div>

      {/* LOCATION */}
      <div className="
      relative
h-[120px]
bg-gray-100
rounded-[10px]
p-3
flex flex-col justify-between
text-gray-900
hover:shadow-md transition
">

  <div className="font-semibold">
    {TEXT.shippingFees}
  </div>

  <div className="flex items-center gap-2">
        <img src="/lebanon.svg" alt="Lebanon" className="w-5 h-5 object-contain" />
        <span className="text-xs">{TEXT.lebanon}</span>
      </div>

  <div className="text-gray-900 text-sm font-medium">
  {shipping
    ? (lang === "AR"
        ? `رسوم التوصيل : $${shipping.default_fee}`
        : `Delivery fees : $${shipping.default_fee}`)
    : <div className="w-16 h-4 bg-gray-200 rounded animate-pulse" />}
</div>

  <button
        onClick={() => {
            setShippingModalOpen(true);

            getAdminShippingSettings()
              .then((data) => setShippingForm(data))
              .catch(() => {});
          }}
        className={`
          absolute bottom-3 ${lang === "AR" ? "left-3" : "right-3"}
          h-8 px-3
          bg-[#f6f6f7]
          border border-gray-300
          rounded-lg
          shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
          text-sm font-medium text-gray-900
          hover:bg-gray-100 hover:shadow-md
          transition
          `}
      >
        {TEXT.edit}
      </button>

</div>

      {/* DOMAIN */}
      <div className="
h-[120px]
bg-gray-100
rounded-[10px]
p-3
flex flex-col justify-between
text-gray-900
hover:shadow-md
transition
">

  {/* TITLE */}
  <div className="font-semibold">
    {TEXT.domain}
  </div>

  {/* CLIENT DOMAIN */}
  <div className="flex items-center justify-between gap-2">
    <div className="flex flex-col">
      <span className="text-[10px] text-gray-500">{TEXT.client}</span>

      <a
        href={domain}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-gray-900 hover:underline truncate max-w-[140px]"
      >
        {domain}
      </a>
    </div>

    <div className="relative">
  <button
    onClick={() => copyToClipboard(domain, "client")}
    className="
    w-7 h-7
    flex items-center justify-center
    bg-[#f6f6f7]
    border border-gray-300
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
    hover:bg-gray-100 hover:shadow-md
    transition
    "
  >
    {copiedKey === "client" ? (
      <FaCheck className="text-green-600 text-[12px]" />
    ) : (
      <FaRegCopy className="text-gray-600 text-[12px]" />
    )}
  </button>

  {/* TOOLTIP */}
  {copiedKey === "client" && (
    <div className="
    absolute -top-7 left-1/2 -translate-x-1/2
    text-[10px] px-2 py-1
    bg-gray-900 text-white
    rounded
    shadow
    whitespace-nowrap
    ">
      {TEXT.copied}
    </div>
  )}
</div>
  </div>

  {/* ADMIN DOMAIN */}
  <div className="flex items-center justify-between gap-2">
    <div className="flex flex-col">
      <span className="text-[10px] text-gray-500">{TEXT.admin}</span>

      <a
        href={adminDomain}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-gray-900 hover:underline truncate max-w-[140px]"
      >
        {adminDomain}
      </a>
    </div>

    <div className="relative">
  <button
    onClick={() => copyToClipboard(adminDomain, "admin")}
    className="
    w-7 h-7
    flex items-center justify-center
    bg-[#f6f6f7]
    border border-gray-300
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
    hover:bg-gray-100 hover:shadow-md
    transition
    "
  >
    {copiedKey === "admin" ? (
      <FaCheck className="text-green-600 text-[12px]" />
    ) : (
      <FaRegCopy className="text-gray-600 text-[12px]" />
    )}
  </button>

  {/* TOOLTIP */}
  {copiedKey === "admin" && (
    <div className="
    absolute -top-7 left-1/2 -translate-x-1/2
    text-[10px] px-2 py-1
    bg-gray-900 text-white
    rounded
    shadow
    whitespace-nowrap
    ">
      {TEXT.copied}
    </div>
  )}
</div>
  </div>

</div>

    </div>

  </div>
</div>

      </>
    )}
    {dateModalOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="w-[360px] bg-white border border-gray-200 rounded-[18px] shadow-[0_30px_60px_rgba(0,0,0,0.16)] overflow-hidden animate-sortOverlay">

      {/* HEADER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-b border-gray-200">
        <h3 className="text-[15px] font-semibold text-gray-800">
          {lang === "AR" ? "نطاق تاريخ" : "Date range"}
        </h3>
      </div>

      {/* BODY */}
      <div className="p-4">

  {/* CALENDAR GRID */}
  <CalendarRangePicker
    rangeStart={rangeStart}
    rangeEnd={rangeEnd}
    setRangeStart={setRangeStart}
    setRangeEnd={setRangeEnd}
  />

</div>

      {/* FOOTER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-t border-gray-200 flex justify-end gap-3">

        <button
          onClick={() => setDateModalOpen(false)}
          className="h-[36px] px-4 border rounded-lg bg-white"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={() => {
  if (!rangeStart || !rangeEnd) return;

  const from = formatLocalDate(rangeStart);
  const to = formatLocalDate(rangeEnd);

  setDraftFrom(from);
  setDraftTo(to);

  setDateType("custom");

  setFilters(prev => ({
    ...prev,
    from,
    to,
  }));

  setDateModalOpen(false);
}}
          className="h-[36px] px-4 bg-[#202223] text-white rounded-lg"
        >
          {TEXT.apply}
        </button>

      </div>
    </div>
  </div>
)}

{showToast && (
  <div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">

    <div className="
      flex items-center gap-3
      px-4 py-3
      bg-white
      border border-gray-200
      rounded-[12px]
      shadow-[0_10px_30px_rgba(0,0,0,0.12)]
    ">

      <div className="
        flex items-center justify-center
        w-7 h-7
        rounded-full
        bg-green-100
      ">
        <span className="text-green-700 text-sm">✓</span>
      </div>

      <div className="text-sm text-gray-800 font-medium">
        {toast}
      </div>

    </div>
  </div>
)}

{shippingModalOpen && shippingForm && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div className="
      w-[400px]
      bg-white
      rounded-[18px]
      shadow-[0_40px_100px_rgba(0,0,0,0.20)]
      overflow-hidden
      animate-sortOverlay
    ">

      {/* HEADER */}
      <div className="px-5 py-4 border-b bg-white flex items-center justify-between">
        <h3 className="text-[16px] font-semibold text-gray-900">
          {lang === "AR" ? "تعديل رسوم الشحن" : "Edit shipping fee"}
        </h3>

        <button
          onClick={() => setShippingModalOpen(false)}
          className="text-gray-400 hover:text-gray-900 text-lg"
        >
          ✕
        </button>
      </div>

      {/* BODY */}
      <div className="px-5 py-5">

        <div className="space-y-2">

          <label className="text-sm font-medium text-gray-900">
            {lang === "AR" ? "رسوم التوصيل" : "Delivery fee"}
          </label>

          <div className="relative">

            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
              $
            </span>

            <input
              type="number"
              value={shippingForm.default_fee}
              onChange={(e) =>
                setShippingForm({
                  ...shippingForm,
                  default_fee: Number(e.target.value),
                })
              }
              className="
                w-full h-[44px] pl-7 pr-3
                border border-gray-300
                rounded-[12px]
                text-sm
                focus:border-black
                focus:ring-2 focus:ring-gray-200
                outline-none
                transition
              "
            />
          </div>

          <p className="text-xs text-gray-500">
            {lang === "AR"
              ? "سيتم تطبيق هذه الرسوم على جميع الطلبات"
              : "This fee will be applied to all orders"}
          </p>

        </div>

      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 border-t bg-[#fafafa] flex justify-end gap-3">

        <button
          onClick={() => setShippingModalOpen(false)}
          className="
            h-[38px] px-4
            border border-gray-300
            rounded-[10px]
            text-sm
            bg-white
            hover:bg-gray-50
            transition
          "
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={saveShipping}
          disabled={savingShipping}
          className="
            h-[38px] px-4
            bg-black text-white
            rounded-[10px]
            text-sm font-medium
            hover:bg-gray-900
            transition
            disabled:opacity-60
          "
        >
          {savingShipping
            ? (lang === "AR" ? "جارٍ الحفظ..." : "Saving...")
            : (lang === "AR" ? "حفظ" : "Save")}
        </button>

      </div>
    </div>
  </div>
)}

      </div>
  </main>
</div>
);
}


export default AdminHome;
